import * as yup from 'yup';

let schema = yup.object().shape({
  login: yup.string().required('Campo obrigatório'),
  password: yup.string().required('Campo obrigatório'),
});

export default schema;
